import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Video — standardised video renderer with opinionated accessibility defaults.
 *
 * Enforced defaults:
 * - `playsInline`: prevents fullscreen takeover on iOS Safari
 *
 * This atom is the uniform control layer for all video rendering parameters.
 * Autoplay policy, lazy loading strategy, caption track requirements, and
 * poster image conventions should all be applied here.
 *
 * @atomic-tier Atom
 * @category Media
 */

export type VideoProps = React.VideoHTMLAttributes<HTMLVideoElement>

const Video = React.forwardRef<HTMLVideoElement, VideoProps>(
  ({ className, playsInline = true, ...props }, ref) => (
    <video
      ref={ref}
      className={cn(className)}
      playsInline={playsInline}
      {...props}
    />
  ),
)
Video.displayName = "Video"

export { Video }
